(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/authenticate/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices/authenticate/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.authenticate = svs.accountservices.authenticate || {};
svs.accountservices.authenticate.isFirstPnp = svs.accountservices.authenticate.isFirstPnp || false;
svs.accountservices.authenticate.login = svs.accountservices.authenticate.login || {};
svs.accountservices.authenticate.utils = svs.accountservices.authenticate.utils || {};

 })(window);